import AOS from 'aos'
import { CountUp } from 'countup.js'
import $ from 'jquery'
import LazyLoad from 'vanilla-lazyload'
import { setupApp } from '@/common/setup-app/setup-app.js'
import 'bootstrap'
import './configuration'

setupApp()

window.$ = window.jQuery = $

/**
 * use countup.js with data attributes
 * Example: <span data-custom-toggle="countUp" data-end-val="5000">0</span>
 *
 */
function initCountUp() {
  const countUpTriggerList = document.querySelectorAll('[data-custom-toggle="countUp"]')
  Array.from(countUpTriggerList).forEach((el) => {
    const countUp = new CountUp(el, Number.parseInt(el.dataset.endVal, 10))
    if (!countUp.error) {
      countUp.start()
    }
  })
}

function initLazyLoad() {
  return new LazyLoad({
    elements_selector: '[data-src]',
  })
}

function initStickyNavbar() {
  const $navbar = $('#nav-main')
  const stickyPoint = 90

  const navbarSticky = () => {
    if ($(window).scrollTop() >= stickyPoint) {
      $navbar.addClass('navbar-sticky')
    }
    else {
      $navbar.removeClass('navbar-sticky')
    }
  }

  $(window).on('scroll', navbarSticky)
  navbarSticky()
}

function initAos() {
  AOS.init({
    offset: 100,
    duration: 1500,
    disable: 'mobile',
  })
}

window.onload = function () {
  initCountUp()
  initStickyNavbar()
  initLazyLoad()
  initAos()
}
